// Third party
import queryString from 'query-string';

// Services
import { logoutUser, getUserToken } from './auth';

// Get listing data (list of page type items)
export function getListingData(props) {
  // Parameters
  const params = {
    // Filters
    ...props.activeFilters,
    // Page
    PageNumber: props.page + 1, // DataGrid starts at page 0, WebService starts at page 1
    // Page Size
    PageSize: props.pageSize,
    // Sort
    OrderColumn: props.sortModel[0].field,
    OrderDirection: props.sortModel[0].sort.toUpperCase(),
  };

  if (props.isSalesChannelListing) {
    params.SalesChannelID = props.salesChannelID;
    params.ShowOnlyAssociated = !props.isModal;
  }

  if (props.fetchAll) {
    params.PageSize = 0; // will be ignored on BE to return all entries (e.g. to get every associated component on save)
  }

  const token = getUserToken();

  // Fetch
  return fetch(
    `${process.env.REACT_APP_API_SERVER}/api${
      props.endpoint
    }?${queryString.stringify(params)}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `${token.type} ${token.value}`
      }
    }
  )
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      }

      return response.json();
    })
    .then((data) => {
      if (!data) {
        throw new Error('Invalid return.');
      } else {
        // Translate/transform server data
        if (data.data && data.data.length > 0) {
          data.data = props.getRows(data.data);
        }

        return data;
      }
    });
}

// Export listing data (list of page type items)
export function exportData(props) {
  // Parameters
  const params = {
    // Filters
    ...props.activeFilters,
    // Page
    PageNumber: props.page,
    // Page Size
    PageSize: props.pageSize,
    // Sort
    OrderColumn: props.sortModel[0].field,
    OrderDirection: props.sortModel[0].sort.toUpperCase(),
  };

  const token = getUserToken();
  // Fetch
  return fetch(`${process.env.REACT_APP_API_SERVER}/api${props.endpoint}/export${props.endpoint.replace('/', '')}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization' : `${token.type} ${token.value}`
    },
    body: JSON.stringify(params)
  })
  .then((response) => {
    if (response.status === 401) {
      logoutUser();
      return;
    }
    alert('Export created. Please check your inbox to access the file.')
    return response.json();
  });
}

const token = getUserToken();
// Delete single data (page type item)
export function deleteData(props) {
  // Fetch
  return fetch(
    `${process.env.REACT_APP_API_SERVER}/api${props.endpoint}/${props.itemId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `${token.type} ${token.value}`
      }
    }
  )
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      } else if(response.status === 409) {
        window.alert(`This item cannot be deleted because it affects other records in the system`);
        return;
      }

      if (response.ok) {
        return response.ok;
      } else {
        return response.json();
      }
    })
    .then((data) => {
      if (typeof data === 'boolean') {
        return data;
      } else {
        throw new Error(
          data.messages.reduce(
            (message, prevMessage) => `${prevMessage}, ${message}`
          )
        );
      }
    });
}

// Get single data (page type item)
export function getDetailData(props) {
  // Fetch
  const token = getUserToken();

  return fetch(
    `${process.env.REACT_APP_API_SERVER}/api${props.endpoint}/${props.itemId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `${token.type} ${token.value}`
      }
    }
  )
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      }

      return response.json();
    })
    .then((data) => {
      if (!data) {
        throw new Error('Invalid return.');
      } else {
        return data;
      }
    });
}

// Save single data (page type item)
export function saveData(props) {
  // convert the formData to a JS object.
  let _fetchBody = {};
  for (var [key, value] of props.formData.entries()) {
    let val_ = '';

    // test if the value is a json string;
    try {
      val_ = JSON.parse(value);
    } catch (error) {
      val_ = value;
    }

    _fetchBody[key] = val_;
  }

  // set the fetch method to POST
  let _fetchMethod = 'POST';
  let _fetchEndpoint = props.endpoint;

  if (props.itemId !== 'new') {
    // if we are not creating a new item
    // then append the itemId to the request endpoint
    _fetchEndpoint += `/${props.itemId}`;
    // and change the request method to POST
    _fetchMethod = 'PUT';
  }

  const token = getUserToken();
  // Fetch
  return fetch(`${process.env.REACT_APP_API_SERVER}/api${_fetchEndpoint}`, {
    method: _fetchMethod,
    headers: {
      'Content-Type': 'application/json',
      'Authorization' : `${token.type} ${token.value}`
    },
    body: JSON.stringify(_fetchBody)
  })
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      }

      return response.json();
    })
    .then((data) => {
      if (!data) {
        throw new Error('Invalid return.');
      } else {
        return data;
      }
    });
}

export function saveComponentsData(props) {
  // Data type
  const endpoint = `/saleschannels/${props.dataTypeIdentificator}`;

  // Parameters
  const body = {
    salesChannelId: props.salesChannelId, //int
    salesChannelVehicleVersionId: props.salesChannelVehicleVersionId, //int
    salesChannelPricingVersionId: props.salesChannelPricingVersionId, //int
    associatedComponents: props.associatedComponents // [0,1,2...]
  }

  const token = getUserToken();

  // Fetch
  return fetch(`${process.env.REACT_APP_API_SERVER}/api${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization' : `${token.type} ${token.value}`
    },
    body: JSON.stringify(body)
  })
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      }

      return response.json();
    })
    .then((data) => {
      if (!data) {
        throw new Error('Invalid return.');
      } else {
        return data;
      }
    });
}
